import client from '../client';
import type {
  IEditDeviceServiceParams,
  IEditPlanPayload,
  IGetDevicePlanDetailParams,
  IGetDeviceServiceListParams,
  IGetPlansParams,
  IPlanUpsertPayload,
  IPostDeviceServiceParams,
} from './types';

export const planApis = {
  // 요금제 생성/관리
  editPlan: (data: IEditPlanPayload) => client.put(`/plan/${data.id}`, data.data),
  getDevicePlans: (data: IGetPlansParams) => client.get(`/device-plans`, { params: data }),
  postDevicePlan: (data: IPlanUpsertPayload) => client.post(`/device-plans`, data),
  getDevicePlanDetail: (data: IGetDevicePlanDetailParams) => client.get(`/device-plans/${data.id}`),

  // 디바이스 서비스 정보 등록
  getDeviceServiceList: (data: IGetDeviceServiceListParams) =>
    client.get(`/device/plan?size=${data.size}&page=${data.page}&filter=${data.searchType}&search=${data.search}`),
  checkValidMac: (mac: string) => client.get(`/device/plan/mac?mac=${mac}`),
  getAllPlans: () => client.get(`/device/plan/type`),
  postDeviceService: (data: IPostDeviceServiceParams) => client.post(`/device/plan`, data),
  editDeviceService: (data: IEditDeviceServiceParams) => client.put(`/device/plan/${data.id}`, data.data),

  // 통신사 요금제
  getTelecomPlanList: (data: { telecom: string; plan: string }) => client.get(`/telecomPlanInfo`, { params: data }),
};
